import { useRef as h, useState as g, useEffect as m, useCallback as l, useLayoutEffect as C } from "react";
const z = (t, e) => {
  const r = typeof e == "number", n = h(r || e == null ? void 0 : e.onDebounce), [o, s] = g(t), { delay: c = 500 } = r || !e ? { delay: e } : e;
  return m(() => {
    const u = setTimeout(() => {
      var a;
      s(t), (a = n.current) == null || a.call(n, t);
    }, c);
    return () => {
      clearTimeout(u);
    };
  }, [t, c]), o;
}, D = (t = !1) => {
  const [e, r] = g(t), n = l(() => {
    r((o) => !o);
  }, []);
  return [e, n, r];
}, T = (t, e) => {
  const { enable: r = !0, position: n = "body-end" } = { ...e }, [o, s] = g(t ? "loading" : "idle");
  return m(
    () => {
      if (!t || !r) {
        s("idle");
        return;
      }
      let c = document.querySelector(`script[src="${t}"]`);
      if (c)
        s(c.getAttribute("data-status"));
      else {
        c = document.createElement("script"), c.src = t, c.async = !0, c.setAttribute("data-status", "loading"), n === "head-start" && document.head.insertBefore(c, document.head.childNodes[0]), n === "head-end" && document.head.appendChild(c), n === "body-start" && document.body.insertBefore(c, document.body.childNodes[0]), n === "body-end" && document.body.appendChild(c);
        const a = (d) => {
          c == null || c.setAttribute("data-status", d.type === "load" ? "ready" : "error");
        };
        c.addEventListener("load", a), c.addEventListener("error", a);
      }
      const u = (a) => {
        s(a.type === "load" ? "ready" : "error");
      };
      return c.addEventListener("load", u), c.addEventListener("error", u), () => {
        c && (c.removeEventListener("load", u), c.removeEventListener("error", u));
      };
    },
    [r, n, t]
    // Only re-run effect if script src changes or enable changes
  ), o;
}, F = (t) => {
  const [e, r] = g(t), n = l((o) => {
    if ("target" in o && "value" in o.target) {
      r(o.target.type === "checkbox" ? o.target.checked : o == null ? void 0 : o.target.value);
      return;
    }
    throw new Error("No value found in event");
  }, []);
  return [e, n];
}, w = typeof window < "u" ? C : m, W = (t) => {
  const e = l((r) => {
    window.document.title = r;
  }, []);
  return w(() => {
    e(t);
  }, [t, e]), { setTitle: e, title: window.document.title };
};
function p(t, e, r, n) {
  const o = h(e);
  w(() => {
    o.current = e;
  }, [e]), m(() => {
    const s = (r == null ? void 0 : r.current) ?? window;
    if (!(s && s.addEventListener))
      return;
    const c = (u) => o.current(u);
    return s.addEventListener(t, c, n), () => {
      s.removeEventListener(t, c, n);
    };
  }, [t, r, n]);
}
const j = () => {
  const [t, e] = g({
    height: 0,
    width: 0
  }), r = () => {
    e({
      height: window.innerHeight,
      width: window.innerWidth
    });
  };
  return p("resize", r), w(() => {
    r();
  }, []), t;
}, V = () => {
  const t = h(!1);
  return m(() => (t.current = !0, () => {
    t.current = !1;
  }), []), l(() => t.current, []);
}, v = (t) => {
  const e = h(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return w(() => {
    e.current = t;
  }, [t]), l((...r) => e.current(...r), [e]);
}, b = "local-storage", y = typeof window > "u", I = (t) => {
  if (!(t === "undefined" || t === null))
    try {
      return JSON.parse(t);
    } catch {
      return t;
    }
}, _ = (t, e, r) => {
  const n = l(
    (i) => r != null && r.serializer ? r.serializer(i) : JSON.stringify(i),
    [r]
  ), o = l(
    (i) => r != null && r.deserializer ? r.deserializer(i) : I(i),
    [r]
  ), s = l(() => {
    if (y)
      return e ?? null;
    try {
      const i = window.localStorage.getItem(t);
      return i ? o(i) : e ?? null;
    } catch {
      return e ?? null;
    }
  }, [t, e, o]), [c, u] = g(s), a = v((i) => {
    y && console.warn(`Tried setting localStorage key “${t}” even though environment is not a client`);
    try {
      const f = i instanceof Function ? i(c) : i;
      window.localStorage.setItem(t, n(f)), u(f), window.dispatchEvent(new CustomEvent(b, { detail: t }));
    } catch (f) {
      console.warn(`Error setting localStorage key “${t}”:`, f);
    }
  }), d = v(() => {
    y && console.warn(`Tried removing localStorage key “${t}” even though environment is not a client`);
    try {
      window.localStorage.removeItem(t), u(e ?? null), window.dispatchEvent(new CustomEvent(b, { detail: t }));
    } catch (i) {
      console.warn(`Error removing localStorage key “${t}”:`, i);
    }
  }), S = l(
    (i) => {
      "key" in i && i.key !== t || u(s());
    },
    [t, s]
  );
  return m(() => {
    u(s());
  }, [t]), p("storage", S), p(b, S), [c, a, d];
}, J = (t, { threshold: e = 0, root: r = null, rootMargin: n = "0%", freezeOnceVisible: o = !1 }) => {
  const [s, c] = g(), u = (s == null ? void 0 : s.isIntersecting) && o, a = ([d]) => {
    c(d);
  };
  return m(() => {
    const d = t == null ? void 0 : t.current;
    if (!!!window.IntersectionObserver || u || !d)
      return;
    const i = { root: r, rootMargin: n, threshold: e }, f = new IntersectionObserver(a, i);
    return f.observe(d), () => f.disconnect();
  }, [t == null ? void 0 : t.current, JSON.stringify(e), r, n, u]), s;
}, U = (t, e) => {
  const { [e]: r, ...n } = t;
  return n;
}, x = (t) => Array.isArray(t), B = (t) => t !== null && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current"), O = (t) => typeof t == "function", P = (t) => typeof t == "boolean", H = (t) => toString.call(t) === "[object Object]", M = (t) => typeof t == "number", q = (t) => typeof t == "string", G = (t, e = 19) => {
  const o = String(t).replace(/\D/g, "").replace(/(\d{4})(?=\d)/g, "$1 ");
  return o.length > e ? o.slice(0, e) : o;
}, K = (t) => {
  const [e, r] = t.fullName ? t.fullName.split(" ") : [t.firstName || "", t.lastName || ""];
  return `${e == null ? void 0 : e.charAt(0)}${r == null ? void 0 : r.charAt(0)}`;
}, E = (t) => `${t.country || ""}`, $ = (t) => {
  const e = t.city && t.postalCode ? `${t.postalCode || ""} ` : `${t.postalCode || ""}`, r = t.city || "", n = E(t), o = (t.postalCode || t.city) && n ? ", " : "";
  return `${e}${r}${o}`;
}, L = (t) => {
  const e = t.route ? `${t.streetNumber || ""} ` : `${t.streetNumber || ""}`, r = t.route || "", n = $(t), o = E(t), s = (t.route || t.streetNumber) && (n || o) ? ", " : "";
  return `${e}${r}${s}`;
}, Q = (t) => {
  if (!t)
    return "";
  const e = L(t), r = $(t), n = E(t);
  return `${e}${r}${n}`.trim();
}, A = {
  currency: "EUR",
  local: "fr-FR",
  maximumSignificantDigits: 1,
  style: "currency"
}, X = (t, e) => {
  const { currency: r, local: n, maximumSignificantDigits: o, style: s } = { ...A, ...e };
  return t ? new Intl.NumberFormat(n, {
    currency: r,
    style: s
  }).format(t) : new Intl.NumberFormat(n, {
    currency: r,
    maximumSignificantDigits: o,
    style: s
  }).format(0);
}, Y = (t) => !t || typeof t != "string" ? "" : t.charAt(0).toUpperCase() + t.slice(1).toLowerCase(), Z = (t) => !t || typeof t != "string" ? "" : t == null ? void 0 : t.toLowerCase().split(" ").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
export {
  Q as addressToString,
  Y as capitalize,
  Z as capitalizeWords,
  G as formatCreditCardNumber,
  K as getInitials,
  x as isArray,
  P as isBoolean,
  O as isFunction,
  M as isNumber,
  H as isObject,
  B as isRef,
  q as isString,
  X as priceAdapter,
  U as removeObjectProperty,
  z as useDebounce,
  W as useDocumentTitle,
  p as useEventListener,
  F as useInputState,
  J as useIntersectionObserver,
  V as useIsMounted,
  w as useIsomorphicLayoutEffect,
  _ as useLocalStorage,
  T as useScript,
  D as useToggle,
  j as useWindowSize
};
